var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"editable-wrapper"}},[_vm._l((_vm.children),function({child, props},index){return [_c(child,_vm._b({key:index,tag:"component"},'component',props,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }